import request from './request'

/** multipart 批量上传图片，字段名 files */
export function uploadImages(files) {
  const fd = new FormData()
  ;(files || []).forEach(f => fd.append('files', f))
  return request.post('/api/Upload/Images', fd)
}
